import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { StudentScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface StoriesWrittenDetailsResponse {
  stories_written_details: {
    created_at: number
    story_id: number
    title: string
    contest_name: string
  }[]
}

export async function storiesWrittenDetails(
  this: StudentEventsService,
  product: LegacyProductRe,
  studentScope: StudentScope,
  period: NormalizedInterval,
): Promise<Nullable<StoriesWrittenDetailsResponse['stories_written_details']>> {
  if (isEmpty(studentScope.ids)) return null

  const url = this.buildUrl('stories_written_details', product, studentScope)
  const query = this.buildQuery(studentScope, period)

  const data = await this.fetchData<StoriesWrittenDetailsResponse>(url, query)
  if (!data) return null

  const { stories_written_details } = data
  if (stories_written_details.length === 0) return null

  return stories_written_details
}
